import { VOLATILIDAD_AIRAC } from "./template-volatilidad/volatilidad-airac.template";
import { ESTRES_AIRAC } from "./templates-estres/estres-airac.template";
import { ADICLA_CONFIG } from "./templates-gap/gap-adicla.template";
import { AIRAC_CONFIG } from "./templates-gap/gap-airac.template";
import { AJUSTADA_AIRAC } from "./templates-liquidez/ajustda-airac.template";
import { RAZONES_AIRAC } from "./templates-prueba-acida/razones-airac.template";
import { CALCES_PLAZOS_CHOROTEGA_ME, CALCES_PLAZOS_CHOROTEGA_MN, CALCES_PLAZOS_CHOROTEGA_TOTAL } from "./template-calces-plazos/calces-plazos-chorotega";
import { FEC_CHOROTEGA_ME, FEC_CHOROTEGA_MN, FEC_CHOROTEGA_TOTAL } from "./template-FEC/fec-chorotega";

export const RELACION_TEMPLATES_GAP = {
  '6931ea5e85cc430012f77552': ADICLA_CONFIG,
  '69a5cd7085cc430012f7764f': AIRAC_CONFIG,
}

export const RELACION_TEMPLATES_PRUEBA_ACIDA = {
  '69a5cd7085cc430012f7764f': RAZONES_AIRAC,
}

export const RELACION_TEMPLATES_LIQUIDEZ_AJUSTADA = {
  '69a5cd7085cc430012f7764f': AJUSTADA_AIRAC,
}

export const RELACION_TEMPLATES_ESTRES = {
  '69a5cd7085cc430012f7764f': ESTRES_AIRAC,
}

export const RELACION_TEMPLATES_VOLATILIDAD = {
  '69a5cd7085cc430012f7764f': VOLATILIDAD_AIRAC,
}

export const RELACION_TEMPLATES_CALCES_PLAZOS_TOTAL = {
  '6986445985cc430012f77600': CALCES_PLAZOS_CHOROTEGA_TOTAL,
}
export const RELACION_TEMPLATES_CALCES_PLAZOS_MN = {
  '6986445985cc430012f77600': CALCES_PLAZOS_CHOROTEGA_MN,
}
export const RELACION_TEMPLATES_CALCES_PLAZOS_ME = {
  '6986445985cc430012f77600': CALCES_PLAZOS_CHOROTEGA_ME,
}
export const RELACION_TEMPLATES_FEC_TOTAL = {
  '6986445985cc430012f77600': FEC_CHOROTEGA_TOTAL,
}
export const RELACION_TEMPLATES_FEC_MN = {
  '6986445985cc430012f77600': FEC_CHOROTEGA_MN,
}
export const RELACION_TEMPLATES_FEC_ME = {
  '6986445985cc430012f77600': FEC_CHOROTEGA_ME,
}
